import './App.css';
import Translator from './Translator/Translator';

function App() {
  return (
    <div className="App">
      <Translator />
    </div>
  );
}

export default App;
